import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import PictureInPictureAltIcon from "@mui/icons-material/PictureInPictureAlt";
import YouTube from "react-youtube";
import { Modal, Paper, Tooltip } from "@mui/material";
import Favempty from "../assets/img/fav.svg";
import Favfill from "../assets/img/favadd.svg";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { useVideo } from "../Contexts/VideosContext";
import gitasevalogo from "../../src/Images/logoGST.png";
import VideoService from "../Services/VideoPlayer";
import { useAudio } from "../Contexts/AudiosContext";
import shareIcon from "../assets/img/shareHover.png"
import { useLocation } from "react-router-dom";

export default function VideoDialog({
  open,
  setOpen,
  children,
  playVideo,
  setPlayVideo,
  videoId,
  onStateChange,
  handleCategoryClick,
  hideModal,
  setHideModal
}:
  any) {
  // Draggable handle only in PiP mode
  const [isPiP, setIsPiP] = useState<boolean>(false);
  const { youtubeTitle, setYoutubetitle, playingVideo, setPlayingVideo } = useVideo();
  const { refVideo } = useVideo();
  // const paperComponent = (props: any) => (
  //   <Draggable
  //     handle="#draggable-dialog-title"
  //     cancel={'[class*="MuiDialogContent-root"]'}
  //     disabled={!isPiP}
  //   >
  //     <div {...props} />
  //   </Draggable>
  // );
  const { t } = useTranslation();
  const pipRef = useRef<HTMLDivElement>(null);
  const options = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
      controls: 1,
      rel: 0,
      modestbranding: 1,
    },
  };
  const handlePiPToggle = () => {
    setIsPiP((prev) => !prev);
  };
  const {
    playbackTime,
    setPlaybackTime,
    videoObjId,
    setVideoObjId,
    likedMsg,
    setLikedMsg,
    setIsLiked,
    isLiked,
    activeMedia,
    setActiveMedia
  } = useVideo();

  const playerRef = useRef<any>(null);

  const onReady = (event: any) => {
    playerRef.current = event.target;
    if (playingAudio) {

      playerRef.current.pauseVideo();
      // setPlayingVideo(false)
    }
    else if (playingVideo) {
      setPlayingAudio(false)
    }
    else if (!playingAudio) {
      setPlayingVideo(true)
    }
    else if (!playingVideo) {
      setPlayingAudio(true)
    }
    // Seek to previous playback time
    if (playbackTime > 0) {
      event.target.seekTo(playbackTime, true);
    }
  };

  // for play video for copy link
  const location = useLocation();
  const { openVideo } = useVideo(); // your video context

  // useEffect(() => {
  //   if (location.state?.videoId && location.state?.autoPlay) {
  //     openVideo(location.state.videoId);
  //   }
  // }, [location.state]);
  // for play video for copy link

  const handleShare = (videoUrl: any) => {
    var videourl = `https://gitaseva.org/videos#id=${videoObjId}`
    navigator.clipboard.writeText(videourl);

    // console.log("videoObjId", videoObjId,);
    // console.log("youtubeTitle", youtubeTitle);
    // console.log("hashId", videoId);
  };

  useEffect(() => {
    // encodeURIComponent
    const interval = setInterval(() => {
      if (
        playerRef.current &&
        typeof playerRef.current.getCurrentTime === "function"
      ) {
        setPlaybackTime(playerRef.current.getCurrentTime());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleFavouriteClick = async () => {
    try {
      if (isLiked) {
        await
          VideoService.removeFavourite(videoObjId);
        setLikedMsg(false);
      } else {
        // await AudiosService.addFavourite(videoObjId);
        await VideoService.addFavourite(videoObjId)
        setLikedMsg(true);
      }
      setIsLiked(!isLiked);
      setTimeout(() => {
        setLikedMsg(null);
      }, 3000);
    } catch (error) {
      console.error("Error updating favourite:", error);
    }
  };

  useEffect(() => {
    if (!isPiP) return;

    const node = pipRef.current;
    if (!node) return;

    let offsetX = 0;
    let offsetY = 0;
    let isDragging = false;

    const onMouseDown = (e: MouseEvent) => {
      isDragging = true;
      offsetX = e.clientX - node.getBoundingClientRect().left;
      offsetY = e.clientY - node.getBoundingClientRect().top;
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    const onMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      const x = e.clientX - offsetX;
      const y = e.clientY - offsetY;
      node.style.left = `${x}px`;
      node.style.top = `${y}px`;
    };

    const onMouseUp = () => {
      isDragging = false;
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    node.addEventListener("mousedown", onMouseDown);

    return () => {
      node.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [isPiP]);

  const { refAudio, playingAudio, setPlayingAudio } = useAudio();

  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.key === "Escape") {
        setOpen(false);
        setIsPiP(false);
        setPlayVideo(!playVideo);
        setPlayingVideo(false);;
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [playVideo]);

  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        setPlayingVideo(false);
        if (reason === "backdropClick") {
          setIsPiP(true); // Switch to PiP
        } else if (reason === "escapeKeyDown") {
          // Ignore or close as per your use case
        }
      }}
      disableEscapeKeyDown
      hideBackdrop
      disableScrollLock={true}
      style={{ pointerEvents: isPiP ? "none" : "auto", cursor: isPiP ? "move" : "auto" }}
    >
      <Paper
        ref={pipRef}
        style={{
          position: "fixed",
          bottom: isPiP ? 20 : "auto",
          right: isPiP ? 20 : "auto",
          top: isPiP ? "auto" : "50%",
          left: isPiP ? "auto" : "50%",
          transform: isPiP ? "none" : "translate(-50%, -50%)",
          width: isPiP ? 320 : 800,
          height: isPiP ? 180 : "",
          margin: isPiP ? 0 : "auto",
          backgroundColor: "white",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25)",
          borderRadius: 10,
          zIndex: 1500,
          pointerEvents: "auto",
          overflow: "hidden",
          outline: "none",
        }}
      >
        {/* Close Button */}

        {/* {hideModal ? "" : (
          <> */}
        <IconButton
          onClick={
            // if (isPiP) setIsPiP(false);
            // else setIsPiP(true);
            handlePiPToggle
          }
          style={{
            position: "absolute",
            top: -1,
            left: 0,
            zIndex: 1,
            height: "30px",
            width: "30px",
            cursor: "pointer",

            backgroundColor: "white",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25)",
          }}
        >
          {isPiP ? <FullscreenIcon /> : <PictureInPictureAltIcon />}
        </IconButton>
        {/* </>
        )
        } */}

        <IconButton
          onClick={() => {
            setOpen(false);
            setIsPiP(false);
            setPlayVideo(!playVideo);
            setPlayingVideo(false);
          }}
          style={{
            position: "absolute",
            top: -1,
            right: 0,
            zIndex: 1,
            height: "30px",
            width: "30px",
            color: "red",

            backgroundColor: "white",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25)",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* YouTube Video */}
        <div style={{ position: "relative", paddingTop: "56.25%" }}>
          <YouTube
            ref={refVideo}
            className="youtube-frame"
            videoId={videoId}
            opts={{
              ...options,
              width: "100%",
              height: "100%",
            }}
            onPlay={() => {
              setPlayingVideo(true)
            }
            }
            onPause={() => {
              setPlayingVideo(false)
            }
            }

            onReady={onReady}
            onStateChange={onStateChange}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              padding: 10,

            }}
          />
        </div>
        <Tooltip
          title={<p style={{ fontSize: "13px" }}>{youtubeTitle}</p>}
          arrow
          placement="top"
        >
          <div
            style={{
              borderBottom: "1px solid lightgray",
              padding: "5px 0px 5px 15px",
              fontWeight: 600,
              fontFamily: "ChanakyaUniBold",
              fontSize: "22px",
              textOverflow: "ellipsis",
            }}
          >
            <span>
              {youtubeTitle?.length > 100
                ? youtubeTitle.slice(0, 100) + "..."
                : youtubeTitle}
            </span>
          </div>
        </Tooltip>
        <div style={{ display: "flex", paddingLeft: "8px" }}>
          <div style={{ marginTop: "5px" }}>
            <img
              src={gitasevalogo}
              style={{
                height: 50,
                width: 50,
                borderRadius: "50%",
                padding: "5px",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "5px 15px",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                fontFamily: "ChanakyaUniBold",
                fontSize: "22px",
              }}
            >
              Gita Seva
            </div>
            {likedMsg !== null && (
              <div
                style={{
                  textAlign: "end",
                  paddingRight: "10px",
                  fontSize: "20px",
                  fontWeight: 500,
                  color: "#f26d00",
                }}
              >
                {likedMsg ? t("videoLiked_tr") : t("videoDislike_tr")}
              </div>
            )}
            <div>
              {/* <img
                src={shareIcon}
                onClick={handleShare}
                style={{ height: 35, cursor: "pointer", marginRight: "10px" }}
                alt="Favourite Icon"
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.2)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              /> */}
              <img
                src={isLiked ? Favfill : Favempty}
                onClick={handleFavouriteClick}
                style={{ height: 35, width: 35, cursor: "pointer" }}
                alt="Favourite Icon"
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.2)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </div>
          </div>
        </div>
      </Paper>
    </Modal>
  );
}
